import { render, staticRenderFns } from "./detailRecords.vue?vue&type=template&id=d50ff088&scoped=true&"
import script from "./detailRecords.vue?vue&type=script&lang=js&"
export * from "./detailRecords.vue?vue&type=script&lang=js&"
import style0 from "./detailRecords.vue?vue&type=style&index=0&id=d50ff088&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50ff088",
  null
  
)

export default component.exports